import * as Yup from "yup";

export const awardSchema = Yup.object().shape({
  name: Yup.string().required("Award name is required"),
  ranking: Yup.string().nullable(),
  accolade: Yup.string().nullable(),
  date: Yup.date()
    .required("Award date is required")
    .max(new Date(), "Award date cannot be in the future"),
  institution_id: Yup.string().required("Institution is required"),
});
